// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__rs3aB","unreadBadge":"styles_unreadBadge__3X5L_","modalContent":"styles_modalContent__3Jq4T","modal":"styles_modal__36RDd"};